import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import clsx from 'clsx';

import PanelExpandButton from '../PanelExpandButton';

import styles, { actionStyles } from './styles';

export const Actions = withStyles(actionStyles)(
  ({ classes, align = 'right', className, children }) => {
    return (
      <div
        data-testid="panel-actions"
        className={clsx(classes.root, className, {
          [classes.leftAlign]: align === 'left'
        })}
      >
        {children}
      </div>
    );
  }
);

export const Title = ({ children, variant = 'subtitle1', ...other }) => {
  return (
    <Typography data-testid="panel-title" variant={variant} {...other}>
      {children}
    </Typography>
  );
};

export const PanelHeader = React.forwardRef((props, ref) => {
  const {
    className,
    classes,
    children,
    title,
    actions,
    renderHeaderContent,
    isCollapsible,
    ...other
  } = props;

  return renderHeaderContent ? (
    <div
      data-testid="panel-header"
      ref={ref}
      className={clsx(classes.root, className)}
      {...other}
    >
      {renderHeaderContent}
    </div>
  ) : (
    <div
      data-testid="panel-header"
      ref={ref}
      className={clsx(classes.root, className)}
      {...other}
    >
      <Title>{title}</Title>
      <Actions>
        {isCollapsible && <PanelExpandButton />}
        {actions}
      </Actions>
    </div>
  );
});

export default withStyles(styles)(PanelHeader);
